export const videoGuideSections = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    videos: [
      {
        id: 'creating-a-vertical',
        title: 'Creating a Vertical',
        description: 'Learn how to create and set up a new Vertical workspace.',
        videoUrl:
          'https://app.vidzflow.com/v/fyGFAv40Iu?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'switching-between-verticals',
        title: 'Switching Between Verticals',
        description: 'Learn how to quickly navigate between your Personal and Joined Verticals.',
        videoUrl:
          'https://app.vidzflow.com/v/GpNuy4uASw?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'setting-your-filter-preferences',
        title: 'Setting Your Filter Preferences',
        description: 'Learn how to customize your discovery and search preferences.',
        videoUrl:
          'https://app.vidzflow.com/v/AnOVrhcRwi?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'understanding-the-workspace',
        title: 'Understanding the Workspace',
        description: 'Get a quick overview of the TSP workspace and platform layout.',
        videoUrl:
          'https://app.vidzflow.com/v/6eHUpBJW8J?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
    ],
  },
  {
    id: 'discovery-resources',
    title: 'Discovery & Resources',
    videos: [
      {
        id: 'finding-new-resources',
        title: 'Finding New Resources (Discovery Refresh)',
        description: 'Learn how to search for newly discovered resources within your Vertical.',
        videoUrl:
          'https://app.vidzflow.com/v/3EMHKtrP2j?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'adding-resources-manually',
        title: 'Adding Resources Manually',
        description: 'Learn how to manually add resources into your workspace.',
        videoUrl:
          'https://app.vidzflow.com/v/3JEYF6RzAh?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'managing-resource-actions',
        title: 'Managing Resource Actions',
        description: 'Learn how to edit, organize, bookmark, and manage resources.',
        videoUrl:
          'https://app.vidzflow.com/v/Ze8QCLLrOn?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'using-the-reference-list',
        title: 'Using the Reference List',
        description: 'Learn how to organize and manage your saved references and citations.',
        videoUrl:
          'https://app.vidzflow.com/v/uDa9EJ3ndM?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'bookmarking-resources',
        title: 'Bookmarking Resources',
        description:
          'Learn how to save important resources across all your Verticals for quick access later.',
        videoUrl:
          'https://app.vidzflow.com/v/wo5uePFqyt?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
    ],
  },
  {
    id: 'collaboration',
    title: 'Collaboration',
    videos: [
      {
        id: 'inviting-collaborators',
        title: 'Inviting Collaborators',
        description: 'Learn how to invite users into your Vertical workspace.',
        videoUrl:
          'https://app.vidzflow.com/v/XS8MrwMUWU?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'managing-user-roles-permissions',
        title: 'Managing User Roles & Permissions',
        description: 'Learn how to manage user roles and workspace permissions.',
        videoUrl:
          'https://app.vidzflow.com/v/xcS9dthYnX?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'managing-resource-visibility',
        title: 'Managing Resource Visibility',
        description: 'Learn how to control which resources collaborators can view.',
        videoUrl:
          'https://app.vidzflow.com/v/ulXErYnCpL?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
    ],
  },
  {
    id: 'workbench-tutorials',
    title: 'Workbench Tutorials',
    subSections: [
      {
        id: 'personal-workbench',
        title: 'Personal Workbench',
        videos: [
          {
            id: 'personal-dashboard-overview',
            title: 'Dashboard Overview',
            description: 'Get a quick overview of your Personal Workbench dashboard.',
            videoUrl:
              'https://app.vidzflow.com/v/oUWHTsXxPg?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'personal-files',
            title: 'Personal Files',
            description: 'Learn how to manage files within your Personal Workbench.',
            videoUrl:
              'https://app.vidzflow.com/v/4AwXS9LFmX?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'personal-calendar',
            title: 'Personal Calendar',
            description: 'Learn how to manage calendar events within your Personal Workbench.',
            videoUrl:
              'https://app.vidzflow.com/v/6Z4aAaHRzv?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'personal-tasks',
            title: 'Personal Tasks',
            description: 'Learn how to create and manage personal tasks.',
            videoUrl:
              'https://app.vidzflow.com/v/yrDL2Wr01W?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'personal-notebook',
            title: 'Personal Notebook',
            description: 'Learn how to create and organize personal notes.',
            videoUrl:
              'https://app.vidzflow.com/v/i47AezXgL8?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'personal-links',
            title: 'Personal Links',
            description: 'Learn how to save and organize important links.',
            videoUrl:
              'https://app.vidzflow.com/v/KXqt7OFel6?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
        ],
      },
      {
        id: 'vertical-workbench',
        title: 'Vertical Workbench',
        videos: [
          {
            id: 'vertical-dashboard-overview',
            title: 'Dashboard Overview',
            description: 'Get a quick overview of the Vertical Workbench dashboard.',
            videoUrl:
              'https://app.vidzflow.com/v/4sMGCiTyHq?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'vertical-files',
            title: 'Vertical Files',
            description: 'Learn how to manage shared files within a Vertical.',
            videoUrl:
              'https://app.vidzflow.com/v/TuIlySUliB?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'vertical-calendar',
            title: 'Vertical Calendar',
            description: 'Learn how to manage shared calendars and events.',
            videoUrl:
              'https://app.vidzflow.com/v/9htAgyYuyB?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'vertical-tasks',
            title: 'Vertical Tasks',
            description: 'Learn how to create and manage collaborative tasks.',
            videoUrl:
              'https://app.vidzflow.com/v/yKjifsWG49?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'vertical-notebook',
            title: 'Vertical Notebook',
            description: 'Learn how to create and organize shared notes.',
            videoUrl:
              'https://app.vidzflow.com/v/F2wN9pU8oS?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
          {
            id: 'vertical-links',
            title: 'Vertical Links',
            description: 'Learn how to save and organize shared links.',
            videoUrl:
              'https://app.vidzflow.com/v/KXqt7OFel6?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
          },
        ],
      },
    ],
  },
  {
    id: 'integrations',
    title: 'Integrations',
    videos: [
      {
        id: 'references-integrations',
        title: 'References Integrations',
        description: 'Learn how to connect and use your various reference managers within TSP.',
        videoUrl:
          'https://app.vidzflow.com/v/uDa9EJ3ndM?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'slack-integration',
        title: 'Slack Integration',
        description: 'Learn how to connect and use Slack within TSP.',
        videoUrl:
          'https://app.vidzflow.com/v/QGFO4N3Nd3?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'google-calendar-integration',
        title: 'Google Calendar Integration',
        description: 'Learn how to connect and manage Google Calendar within TSP.',
        videoUrl:
          'https://app.vidzflow.com/v/6Z4aAaHRzv?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'cloud-storage-file-attachments',
        title: 'Cloud Storage & File Attachments',
        description: 'Learn how to connect cloud storage services and attach files to resources.',
        videoUrl:
          'https://app.vidzflow.com/v/7VEV1wluLk?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
    ],
  },
  {
    id: 'account-workspace',
    title: 'Account & Workspace',
    videos: [
      {
        id: 'managing-your-subscription',
        title: 'Managing Your Subscription',
        description: 'Learn how to manage your subscription and billing settings.',
        videoUrl:
          'https://app.vidzflow.com/v/vVp4oUOy7m?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'upgrading-your-account',
        title: 'Upgrading Your Account',
        description: 'Learn how to upgrade your account and unlock additional features.',
        videoUrl:
          'https://app.vidzflow.com/v/uJ9yE9PlU9?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
      {
        id: 'downloading-a-vertical',
        title: 'Downloading a Vertical',
        description: 'Learn how to download and export your Vertical data.',
        videoUrl:
          'https://app.vidzflow.com/v/L4VgKfFMoy?dq=576&ap=false&muted=false&loop=false&ctp=true&bv=false&piv=false&playsinline=false&bc=%234E5FFD&controls=play-large%2Cplay%2Cprogress%2Ccurrent-time%2Cmute%2Cvolume%2Csettings%2Cfullscreen',
      },
    ],
  },
];
